export default __webpack_public_path__ + "static/media/mareos_vertigo.688beff9.pdf";